import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  PRODUCT_SURVEILLANCE,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_BAXTER_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_BAXTER,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_BAXTER_EMPLOYEE,
  DATE_MESSAGE_BAXTER_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_BAXTER_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_BAXTER_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  BAXTER_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  BAXTER_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_BAXTER,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  VALID_DATE,
  QUANTITY,
  EDIT,
  DELETE,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  BAXTER_EMAIL_ADDRESS,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  FEEDBACK_SUBMITTED,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  BAXTER_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  PRIVACY_NOTICE,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_BAXTER,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Portal opinii o produktach";
translations[LANDING_BRIEF] = "Portal Opinii o Produktach służy do przesyłania poufnych informacji i opinii na temat produktów firmy Baxter.";
translations[LANDING_LANGUAGE_SELECTOR] = "Wybierz preferencje językowe";
translations[LANDING_COUNTRY_SELECTOR] = "Wybierz kraj zdarzenia";
translations[LANDING_TERMS] = "Przeczytałem i akceptuję Warunki użytkowania i Oświadczenie o ochronie prywatności dotyczące Portalu Opinii o Produktach.";
translations[LANDING_TERMS_ERROR] = "Musisz przeczytać i zaakceptować treść Warunków użytkowania, Oświadczenia o ochronie prywatności i Dodatkowych Warunków korzystania z Portalu o Produktach oraz Oświadczenia o ochronie prywatności dla Portalu Opinii o Produktach";
translations[LANDING_CAPTCHA_ERROR] = "Potwierdź, że nie jestes robotem";
translations[APP_DESCRIPTION] = "Portal Opinii o Produktach służy do przekazywania informacji o produktach. Jeśli napotkałeś jakikolwiek problem z produktem Baxter, zachęcamy do podzielenia się szczegółami tego zdarzenia. Wszystkie informacje zwrotne są dla nas niezbędne, aby realizować wspólne cele ciągłego ulepszania produktów i zadowolenia z produktu.";
translations[LANDING_TERMS_I_HAVE_READ] = "Zapoznałem się z powiązaną Informacją o ochronie prywatności dla Portalu opinii o produktach firmy Baxter i rozumiem, że firma Baxter Healthcare Corporation („Baxter”) zwraca się o moją zgodę na wykorzystywanie, ujawnianie i przetwarzanie moich danych osobowych w celach opisanych w Informacji o ochronie prywatności. Wyrażam zgodę na:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "Wykorzystanie, ujawnianie, przechowywanie i przetwarzanie moich danych osobowych (w tym wszelkich danych wrażliwych, takich jak dane dotyczące zdrowia, które zdecyduję się podać) do celów określonych w Informacji o ochronie prywatności.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "Przekazywanie moich danych osobowych (w tym danych wrażliwych, takich jak dane związane ze zdrowiem, które zdecyduję się podać) poza mój kraj i do innego kraju, w którym mogą obowiązywać mniej rygorystyczne przepisy o ochronie danych lub nie mają żadnych przepisów o ochronie danych.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Rozumiem, że ta zgoda jest dobrowolna i że mogę zmienić zdanie w dowolnym momencie i cofnąć zgodę, kontaktując się z firmą Baxter, korzystając z danych kontaktowych podanych w Informacji o ochronie prywatności. Rozumiem, że wycofanie zgody nie wpłynie na zgodność z prawem przetwarzania przed jej cofnięciem.";
translations[MENU_FEEDBACK_FORM] = "Rozpocznij opinię o produkcie";
translations[MENU_FEEDBACK_STATUS] = "Sprawdź stan opinii o produkcie";
translations[MENU_FORM_INTAKE] = "Reporter/Dane kontaktowe";
translations[MENU_FORM_EVENT_DETAILS] = "Szczegóły wydarzenia";
translations[MENU_FORM_PRODUCT_INFO] = "Informacje o produkcie";
translations[SYSTEM_FEEDBACK_FORM] = "Wypelnij formularz opinii o produkcie";
translations[SYSTEM_FEEDBACK_STATUS] = "Sprawdź stan opinii o produkcie";
translations[SUBMIT_FEEDBACK] = "Kliknij tutaj, aby przesłać opinię";
translations[CHECK_SUBMITTED_FEEDBACK] = "Kliknij tutaj, aby sprawdzić poprzednio przesłane informacje zwrotne.";
translations[BTN_LAUNCH_FORM] = "Uruchom formularz";
translations[BTN_CHECK_STATUS] = "Sprawdź status";
translations[FORM_TITLE] = "Formularz opinii o produkcie";
translations[FORM_SUB_TITLE] = "Jeśli zdarzenie dotyczy wielu pacjentów, wypełnij formularz dla każdego z nich.";
translations[FORM_MANDATORY_FIELDS] = "Wymagane są wszystkie pola z oznaczeniem *";
translations[BUTTON_PREV] = "Poprzedni";
translations[BUTTON_NEXT] = "Następny";
translations[BUTTON_SUBMIT] = "Zatwierdź";
translations[SELECT_RESPONSE] = "Wybierz odpowiedź";
translations[FUNCTION_ROLE] = "Funkcja/Rola";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Numer konta klienta";
translations[ENTER_CUSTOMER_ACCOUNT] = "Wprowadź konto klienta";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "Jaki jest numer konta klienta zaangażowanego w zgłoszone zdarzenie?";
translations[EVENT_REPORTED] = "Czy to zdarzenie było wcześniej zgłoszone ( do Baxter lub jakiegokolwiek innego podmiotu)?";
translations[REFERENCE_NUMBER] = "Numer referencyjny powiązany z tym zdarzeniem";
translations[ENTER_REFERENCE] = "Wprowadź odniesienie";
translations[WHO_REPORTED_TO] = "Komu zostało to zgłoszone?";
translations[WHO_WAS_NOTIFIED] = "Podać imię i nazwisko, kto został powiadomiony?";
translations[ENTER_NAME] = "Wprowadź nazwę";
translations[PRODUCT_SURVEILLANCE] = "Czy Baxter może skontaktować się z Tobą lub z kimś innym, w przypadku dodatkowych pytan?";
translations[YOUR_NAME] = "Twoje imię";
translations[OCCUPATION] = "Zawód";
translations[PHONE_NUMBER] = "Numer telefonu";
translations[ENTER_PHONE_NUMBER] = "Wprowadź numer telefonu";
translations[ENTER_EMAIL] = "Wpisz adres e-mail";
translations[EMAIL_ADDRESS] = "Adres e-mail";
translations[ENTER_ADDRESS] = "Podaj adres e-mail";
translations[ENTER_NA_IF_UNKNOWN] = "Wprowadź NA, jeśli jest nieznany";
translations[FACILITY_HOSPITAL] = "Nazwa placówki/szpitala lub dystrybutora (jeśli dotyczy)";
translations[ENTER_FACILITY] = "Podaj nazwe placówki";
translations[ADDRESS_1] = "Adres 1";
translations[ADDRESS_2] = "Adres 2";
translations[CITY] = "Miasto";
translations[STATE] = "Województwo";
translations[POSTAL_CODE] = "Kod pocztowy";
translations[COUNTRY] = "Kraj";
translations[END_USER_CUSTOMER] = "Czy ten problem został wykryty przez użytkownika końcowego/klienta?";
translations[ADDITIONAL_CONTACT_PERSON] = "Dodatkowa osoba kontaktowa";
translations[ADDITIONAL_PHONE] = "Dodatkowy numer telefonu kontaktowego";
translations[ADDITIONAL_EMAIL] = "Dodatkowa adres kontakotowy e-mail ";
translations[ANOTHER_FACILITY_ADDRESS] = "Dodaj inny obiekt/adres";
translations[ANOTHER_FACILITY_HOSPITAL] = "Inna nazwa placówki/szpitala lub dystrybutora (jeśli dotyczy)";
translations[ANOTHER_ENTER_FACILITY] = "Podaj nazwe placówki";
translations[ANOTHER_ADDRESS_1] = "Adres 1";
translations[ANOTHER_ADDRESS_2] = "Adres 2";
translations[ANOTHER_CITY] = "Miasto";
translations[ANOTHER_STATE] = "Województwo";
translations[ANOTHER_POSTAL_CODE] = "Kod pocztowy";
translations[ANOTHER_COUNTRY] = "Kraj";
translations[LOT_SERIAL_NUMBER] = "Numer partii/numer seryjny";
translations[ENTER_LOT_SERIAL_NUMBER] = "Wprowadź numer partii/numer seryjny";
translations[HELP_LOT_SERIAL_NUMBER] = "Wprowadź Nieznany, jeśli nie znasz numeru Partii/Numeru seryjnego, lub jeśli zapytałeś raportującego, a on nie znał odpowiedzi.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Kod produktu";
translations[PRODUCT_CODE] = "Kod produktu";
translations[ENTER_PRODUCT_CODE] = "Wprowadź kod produktu";
translations[HELP_PRODUCT_CODE] = "Wprowadź Nieznany, jeśli nie znasz kodu produktu, lub jeśli zapytałeś raportującego, a on nie znał odpowiedzi.";
translations[NDC] = "Krajowy kod leku (NDC)";
translations[ENTER_NDC] = "Wprowadź NDC";
translations[UDI] = "Unikalny identyfikator urządzenia (UDI)";
translations[ENTER_UDI] = "Wpisz UDI";
translations[PRODUCT_NAME] = "Nazwa produktu";
translations[ENTER_PRODUCT_NAME] = "Wprowadź nazwę produktu";
translations[HELP_PRODUCT_NAME] = "Podaj nazwę lub opis produktu";
translations[BEST_DESCRIBES] = "Proszę dokonać wyboru, który najlepiej opisuje zgłoszony problem";
translations[QUANTITY_TO_SELECT] = "Ilość do wybrania";
translations[ENTER_QUANTITY] = "Wprowadź ilość";
translations[HELP_QUANTITY] = "Liczba produktów ze zgłoszonym problemem";
translations[UNIT] = "Jednostka";
translations[AVAILABLE_TO_RETURNED] = "Czy rzeczywisty produkt ze zgłoszonym problemem może zostać zwrócony do firmy Baxter w celu oceny?";
translations[PHOTOGRAPH_AVAILABLE] = "Czy zdjęcie lub film z zaraportowanym produktem jest dostępny?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Upewnij się, że zgłoszony problem jest widoczny na zdjęciu lub filmie.";
translations[UPLOAD_IMAGES] = "Prześlij zdjecia";
translations[REPORTER_NAME] = "Imie I nazwisko  osoby raportującej";
translations[REPORTER_FACILITY] = "Nazwa obiektu osoby raportującej";
translations[REPORTER_OCCUPATION] = "Zawód osoby raportującej";
translations[ENTER_NUMBER] = "Wprowadź numer";
translations[REPORTER_PHONE_NUMBER] = "Numer telefonu osoby raportującej";
translations[REPORTER_EMAIL_ADDRESS] = "Adres e-mail osoby raportującej";
translations[EMPLOYEE_NAME] = "Nazwisko pracownika";
translations[EMPLOYEE_PHONE_NUMBER] = "Numer telefonu pracownika";
translations[EMPLOYEE_EMAIL_ADDRESS] = "Adres e-mail pracownika";
translations[RETURNING_FOR_INVESTIGATION] = "Ile próbek (w jednostkach) ze zgłoszonym problemem zwracasz do oceny/ ewaluacji?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Próbki te powinny być produktem ze zgłoszonym problemem.";
translations[UNUSED_BAXTER_PRODUCT] = "Czy istnieje jeden nieużywany produkt Baxter z tej samej partii, który może zostać zwrócony do firmy Baxter w celu oceny?";
translations[YOU_INDICATED_SAMPLES] = "Wskazałeś, że próbki są dostępne do oceny, czy jesteś w stanie dostarczyć je do swojego ośrodka służby zdrowia?";
translations[SAMPLE_RETURN_KIT] = "Wskazałeś, że próbki są dostępne do oceny, proszę potwierdzić podany adres, aby wysłać próbkę zestawu zwrotnego:";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "Na ten adres zostanie wysłana przesyłka z etykietą przedpłaconą, aby zwrócić próbkę";
translations[SAME_AS_MY_ADDRESS] = "Taki sam jak mój adres";
translations[OTHER_CONTACT_NAME] = "Imię i nazwisko innego kontaktu";
translations[OTHER_CONTACT_OCCUPATION] = "Zawód innych osób kontaktowych";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Numer telefonu innego kontaktu";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "Adres e-mail innego kontaktu";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "Wybrany przez Ciebie produkt jest produkowany przez inną firmę. Czy możemy przekazać im Twoje dane kontaktowe, jeśli mają dodatkowe pytania dotyczące Twojego raportu?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "Czy klient wyraźnie zażądał wyników dochodzenia?";
translations[EXPLICITLY_REQUEST_CREDIT] = "Czy klient wyraźnie zażądał rekompensaty?";
translations[PRODUCT_FROM_BAXTER] = "Czy klient zamawia produkt bezpośrednio od firmy Baxter?";
translations[QUANTITY_REQUESTED_CREDIT] = "Numer (-y) partii i ilość wnioskowanej rekompensaty:";
translations[ENTER_OCCUPATION] = "Wprowadź zawód";
translations[LOT_QUANTITY_NUMBER] = "Wprowadź numer i ilość partii";
translations[WHOLESALERS_NAME] = "Jaki jest Nazwa i lokalizacja hurtowni (miasto, wojewodztwo)";
translations[PLACE_WHOLESALERS_NAME] = "Nazwa i lokalizacja hurtowni (miasto, wojewodztwo)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Dodaj produkt do siatki";
translations[SAVE] = "Zapisz";
translations[CANCEL] = "Anuluj";
translations[ADD_MORE_PRODUCTS] = "DODAJ Więcej produktów";
translations[REPORTER_ADDRESS] = "Adres osoby raportującej";
translations[ATTACHMENTS] = "Załączniki";
translations[DATE_OF_EVENT] = "Data wydarzenia";
translations[DATE_OF_EVENT_MSG] = "Data zdarzenia nie może być datą po pierwszym powiadomieniu pracownika firmy Baxter. Podaj prawidłową datę.";
translations[HELP_DATE_OF_EVENT] = "jeśli istnieje wiele znanych dat zdarzenia, prosimy o wypełnienie formularza dla każdej daty.";
translations[DATE_BAXTER_EMPLOYEE] = "Data pierwszego powiadomienia pracownika Baxter";
translations[DATE_MESSAGE_BAXTER_EMPLOYEE] = "(Podana data nie musi być taka sama jak data wprowadzenia informacji.)";
translations[DURING_WHAT_PROCESS] = "Podczas jakich etapów procesu wystąpiło zdarzenie?";
translations[WAS_THE_PATIENT] = "Czy pacjent był podłączony (leczenie trwało) w momencie zdarzenia?";
translations[WERE_YOU_CONNECTED] = "Czy byłeś połączony (w czasie leczenia) w momencie zdarzenia?";
translations[PROVIDE_ANY_ADDITIONAL] = "Podaj wszelkie dodatkowe informacje dotyczące zdarzenia/problemu";
translations[HELP_YOU_IDENTIFIED_MORE] = "Zidentyfikowałeś więcej niż jeden produkt i problem, proszę wyjaśnij, który produkt jest zwiazany z danym problemem.";
translations[ENTER_DETAILS] = "Wprowadź szczegóły";
translations[PROVIDE_ANY_ATTACHMENT] = "Dodaj dowolny zalacznik powiazany ze zdarzeniem";
translations[WAS_NEGATIVE_MEDICAL] = "Czy w wyniku zdarzenia wystąpiły jakiekolwiek negatywne skutki medyczne, objawy lub uraz?";
translations[WAS_MEDICAL_INTERVENTION] = "Czy zapewniono leczenie, interwencję medyczną lub eskalację opieki w celu przeciwdziałania zgłoszonemu zdarzeniu?";
translations[PROVIDE_DETAILS] = "Podaj szczegóły";
translations[REQUIRED_TREATMENT] = "Wymagane leczenie/interwencja medyczna";
translations[ENTER_TREATMENT] = "Wprowadź leczenie";
translations[RELEVANT_TESTS] = "Odpowiednie badania, w tym dane laboratoryjne:";
translations[HELP_RELEVANT_TESTS] = "Wprowadzić odpowiednie badania";
translations[RELEVANT_MEDICAL_HISTORY] = "Odpowiedni wywiad medyczny, w tym istniejące wcześniej schorzenia:";
translations[ENTER_HISTORY] = "Wprowadź historię";
translations[PATIENT_NAME] = "Imię i nazwisko pacjenta";
translations[PATIENT_INITIALS] = "Inicjały lub pelne imię i nazwisko pacjenta. Jeśli zdarzenie dotyczy wielu pacjentów, wypełnij formularz dla każdego z nich.";
translations[PATIENT_PHONE_NUMBER] = "Numer telefonu pacjenta";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "Nie chcę podawać";
translations[PATIENT_EMAIL_ADDRESS] = "Adres e-mail pacjenta";
translations[PATIENT_ADDRESS] = "Adres pacjenta";
translations[SAME_ADDRESS] = "Ten sam adres";
translations[DRUG_BEING_USED] = "Czy lek Baxter był używany w czasie wydarzenia?";
translations[PATIENT_IDENTIFIER] = "Identyfikator pacjenta";
translations[PATIENT_AGE_OR_DOB] = "Wiek pacjenta lub data urodzenia";
translations[ENTER_PATIENT_AGE] = "mm/dd/rrrr, Wprowadź wiek pacjenta";
translations[PATIENT_GENDER] = "Płeć pacjenta";
translations[PATIENT_WEIGHT] = "Waga pacjenta";
translations[ENTER_WEIGHT] = "Wprowadź wagę";
translations[PATIENT_WEIGHT_UNIT] = "Jednostka wagi pacjenta";
translations[MY_NAME] = "Moje Imię";
translations[ENTER_IN_YOUR_CONTACT] = "Wprowadź swoje dane kontaktowe";
translations[MY_PHONE_NUMBER] = "Mój numer telefonu";
translations[MY_EMAIL_ADDRESS] = "Mój adres e-mail";
translations[MY_ADDRESS] = "Mój adres";
translations[NAME_OF_BAXTER_DRUG] = "Nazwa leku Baxter";
translations[ENTER_DRUG_NAME] = "Wprowadź nazwę leku";
translations[PLEASE_PROVIDE_THE_NAME] = "Podaj nazwę lub kod produktu leku Baxter. Podaj nazwy wszystkich leków firmy Baxter używanych w momencie zgłoszenia problemu";
translations[SELECT_THE_COMPONENT] = "Wybierz komponent, który miał problem";
translations[USE_THE_DIAGRAM] = "Użyj powyższego schematu (rysunek 1), aby określić lokalizację uszkodzonego zestawu jednorazowego użytku.";
translations[TYPE_OF_DAMAGE] = "Proszę opisać rodzaj uszkodzenia";
translations[PLEASE_ENTER_VALUE] = "Wprowadź wartość";
translations[WAS_THE_PRODUCT_KINKED] = "Czy produkt był załamany, popękany, wygięty, przecięty itp.?";
translations[WERE_ANY_CLEANING] = "Czy na Produkcie zastosowano jakieś roztwory czyszczące, rozpuszczalniki lub środki dezynfekujące?";
translations[WHAT_WAS_THE_DISINFECTANT] = "Jaka była nazwa/marka środka dezynfekującego i jak go użyto?";
translations[NOTE_BAXTER_LABELING] = "Etykieta Baxter informuje o nie stosowaniu wybielacza, nadtlenku wodoru, alkoholu lub środka antyseptycznego zawierającego alkohol do produktu. Korzystanie z tych produktów może spowodować pojawienie się pęknięć produktu.";
translations[SELECT_ALL_THAT_APPLY] = "Zaznacz wszystkie, które mają zastosowanie";
translations[DID_FOLLOWING_OCCUR] = "Czy wystąpiło którekolwiek z poniższych problemów?";
translations[SELECT_THE_LOCATION] = "Wybierz lokalizację z uszkodzeniami na Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "Czy produkt był narażony na nadmierną siłę (tzn. uderzenie, przewrócenie) przed wystąpieniem problemu?";
translations[HOW_LONG_TRANSFER] = "Jak długo zestaw transferowy jest używany?";
translations[WAS_THERE_DIFFICULTY] = "Czy były jakieś trudności przy otwieraniu lub zamykaniu zacisku skręcanego?";
translations[WAS_DEVICE_OR_TOOL] = "Czy urządzenie lub narzędzie było używane do otwierania lub zamykania zacisku skręcanego?";
translations[DESCRIBE_HOW_PRODUCT] = "Opisz, w jaki sposób produkt był trudny w użyciu (Wybierz wszystkie, których to dotyczy)";
translations[DID_YOU_OBSERVE] = "Czy zaobserwowałeś jakiekolwiek uszkodzenia produktu (np. rozcięcie, dziura, pęknięcie)?";
translations[WERE_DIFFICULTIES_PUTTING] = "Czy były jakieś trudności z założeniem Minicap na zestaw transferowy i skręceniem zgodnie z ruchem wskazówek zegara, aż będzie trwale zabezpieczony?";
translations[WAS_THE_TRANSFER] = "Czy zestaw transferowy został zastąpiony z powodu tego zdarzenia?";
translations[SELECT_TYPE_OF_FLOW] = "Wybierz typ problemu z przepływem";
translations[WAS_ANYTHING_BLOCKING] = "Czy coś blokowało przepływ?";
translations[WAS_ANY_ALARM] = "Czy wystąpił jakiś alarm?";
translations[SELECT_BEST_DESCRIBE] = "Wybierz opcję, która najlepiej opisuje problem";
translations[WERE_THE_MINICAPS] = "Czy Minicap-y były narażone lub przechowywane w ciepłym/zimnym środowisku?";
translations[WAS_THE_SPONGE_VISIBLE] = "Czy gąbka była widoczna wewnątrz Minicap?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "Gdzie znajduje się cząstka stała/materiał obcy?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Opisz dokładną lokalizację, wielkość, kształt i kolor cząstek stałych/materiału obcego:";
translations[WAS_THE_PARTICULATE_MATTER] = "Czy w produkcie znalazły się cząstki stałe/ materiał obcy?";
translations[DOES_THE_PARTICULATE_MATER] = "Czy cząstki stałe/obce materiały wydają się być kawałkami materiału produktu?";
translations[WHAT_COMPONENT_DOES] = "Z jakiego komponentu wydaje się pochodzic cząstka stala?";
translations[SELECT_CONNECTION_ISSUE] = "Wybierz opcję, która najlepiej opisuje problem z połączeniem";
translations[WERE_ASSIST_DEVICES] = "Czy do połączenia jednorazowego użytku użyto jakichkolwiek urządzeń pomocniczych lub narzędzi?";
translations[WERE_ANY_DIFFICULTIES] = "Czy zauważono jakieś trudności podczas początkowego połączenia lub rozłączenia?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Podaj informacje o drugim produkcie, który brał udział w problemie z połączeniem";
translations[WERE_THE_SPIKE_LUER] = "Czy złącza spike/luer były obracane zgodnie z ruchem wskazówek zegara, aż zostały mocno zabezpieczone?";
translations[BAXTER_LABELING_STATES] = "Etykieta Baxter informuje, aby upewnić się, że wszystkie jednorazowe połączenia zestawu są bezpieczne i dopasowane przed rozpoczęciem terapii.";
translations[WERE_PETS_OR_ANIMALS] = "Czy jakiekolwiek zwierzęta mogły uszkodzić zestaw jednorazowego użytku?";
translations[BAXTER_LABELING_CONTAMINATION] = "Etykieta Baxter informuje, że zanieczyszczenie szlaków płynnych może nastąpić, jeśli zwierzę ugryzie zestaw jednorazowego użytku. Aby zmniejszyć to ryzyko, nie należy przeprowadzać dializy w tym samym pomieszczeniu co zwierzęta domowe.";
translations[WERE_OTHER_ISSUES] = "Czy wystąpiły inne problemy lub trudności związane z kolcem / końcówką luer (np. pęknięcie, zdeformowanie, wygięcie itp.)?";
translations[WAS_MINICAP_TWISTED] = "Czy Minicap był zakrecony zgodnie z ruchem wskazówek zegara ze złączem zestawu transferowego, do momentu stabilnego  zabezpieczenia?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Czy były jakieś trudności z umieszczeniem Minicap na zestawie transferowym?";
translations[DID_TRANSFER_SET_CONNECTORS] = "Czy złącza zestawu transferowego miały widoczne uszkodzenia lub pozostałości na gwintach?";
translations[WHAT_WAS_THE_ALARM] = "Co to był za alarm?";
translations[WHERE_OBSERVED_DAMAGE] = "Gdzie było zaobserwowane uszkodzenie (wybierz wszystkie, które mają zastosowanie)?";
translations[SELECT_THE_TYPE_OBSERVED] = "Wybierz typ obserwowanego uszkodzenia (wybierz wszystkie, które mają zastosowanie):";
translations[DID_DAMAGE_CAUSE_LEAK] = "Czy uszkodzenie spowodowało przeciek?";
translations[WAS_THE_SHIPPING_CARTON] = "Czy karton wysyłkowy był otwarty ostrym przedmiotem?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Wybierz typ zaobserwowanego problemu przepływu";
translations[HOW_LONG_WAS_STORAGE] = "Jak długo produkt był w magazynie, zanim został znaleziony przeterminowany?";
translations[WAS_THERE_AN_ADAPTER] = "Czy z produktem używano adaptera lub innego urządzenia?";
translations[NAME_AND_MODEL] = "Jaka jest nazwa i model adaptera lub innego używanego urządzenia?";
translations[NAME_VAPORIZER] = "Jaka jest nazwa i model Vaporizer?";
translations[WAS_VIAL_INVERTED] = "Czy dołączona fiolka została odwrócona przed wciśnięciem roztworu do fiolki?";
translations[WHAT_VIAL_USED] = "Jakie są informacje o produkcie stosowanej fiolki?";
translations[DRUG_NAME_MANUFACTURER] = "Nazwa leku, producent, rozmiar fiolki";
translations[WERE_BREAK_FRANGIBLE] = "Udało ci się złamać łamliwy element, używając ruchu góra - dół?";
translations[WAS_ALARM_ASSOCIATED] = "Czy wystąpił jakiś alarm związany z brakiem przepływu?";
translations[WHAT_PART_DISCOLORED] = "Jaka część produktu została zgłoszona jako odbarwiona? (zaznacz wszystkie, których to dotyczy)";
translations[DESCRIBE_DISCOLORATION] = "Opisz przebarwienie (opisz kolor, odcień, barwę, ton, itp.):";
translations[HOW_PRODUCT_STORED] = "Jak przechowywano produkt?";
translations[DOES_DISCOLORATION_APPEAR] = "Czy przebarwienia wydają się być nieprzezroczyste, mgliste, mętne i/lub mają oznaczenia zaokrąglone/ w kształcie plastra miodu?";
translations[WHICH_CHAMBER_DISCOLORED] = "Która komora była przebarwiona na worku?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "Czy uszczelka odklejana  lub międzykomorowa była już uszkodzona/aktywowana?";
translations[WAS_DISCOLORATION_NOTICED] = "Czy odbarwienia zostały zauważone przez szkło w waporyzatorze?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Wybierz opcję, która bardziej szczegółowo opisuje problem:";
translations[WHAT_DEVICE_HAD_ALARM] = "Jakie urządzenie zaalarmowało?";
translations[WHAT_MISSING_MISASSEMBLED] = "Jakiego komponentu brakowało lub źle zmontowano?";
translations[RECONSTITUTION_ISSUE] = "Podaj bardziej szczegółowy opis problemu rekonstytucji ";
translations[WHAT_MEDICATION_SOLUTION] = "Z jakim lekiem/roztworem produkt był rozpuszczony?";
translations[WHAT_VOLUME_MEDICATION] = "Jaka była objętość leku/roztworu użytego do rozpuszczania?";
translations[WHAT_DEVICES_RECONSTITUTION] = "Jakie inne urządzenia użyto podczas rekonstytucji (nazwa/producent, rozmiar igły/miernika itp.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "Czy produkt był narażony na działanie ciepła?";
translations[DESCRIBE_EXPOSURE] = "Opisz ekspozycję (temperatura, jak długo itd.)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "Jaką technikę użyto do aktywacji roztworu?";
translations[WAS_DAMAGE_OBSERVED] = "Czy przed aktywacją zaobserwowano jakiekolwiek uszkodzenia produktu?";
translations[DESCRIBE_THE_DAMAGE] = "Opisz uszkodzenia";
translations[APPROXIMATELY_SOLUTION_POWDER] = "W przybliżeniu, ile roztworu lub proszku było niedopełnione lub przepełnione?";
translations[WAS_LEAK_OBSERVED] = "Czy zaobserwowano jakikolwiek wyciek?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "Jaki składnik lub cecha produktu jest trudna w użyciu?";
translations[HOW_WAS_DIFFICULT_USE] = "W jaki sposób produkt był trudny w użyciu?";
translations[WHERE_MATTER_FOREIGN] = "Gdzie znajdowały się cząstki stałe/materiał obcy?";
translations[DOES_PARTICULATE_MATTER] = "Czy cząstki stałe/obce materiały wydają się być kawałkami materiału produktu?";
translations[DESCRIBE_EXACT_LOCATION] = "Opisz dokładną lokalizację, kolor, rozmiar, kształt i fakturę cząstek stałych/materiału obcego:";
translations[WAS_MATTER_FOREIGN] = "Czy cząstki stałe/obce materiały były osadzone w produkcie (nie poruszając się swobodnie)?";
translations[WHEN_MATTER_FOREIGN] = "Kiedy zaobserwowano cząstkę stałą/materiał obcy?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Podaj informacje o produkcie dla dodanego leku:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Nazwa produktu, kod produktu, numer partii produktu, nazwa marki";
translations[DESCRIBE_SPIKING] = "Opisz technikę przebijania kolcem lub rekonstytucji, która została zastosowana:";
translations[INCLUDE_NEEDLE] = "Uwzględnij rozmiar igły/miernik, kąt nakłuwania/przekłuwania, liczbę prób";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "Jaki zestaw administracyjny lub urządzenie do rekonstytucji zostało użyte?";
translations[INCLUDE_MANUFACTURER] = "Dołącz producenta, nazwę produktu, kod produktu, partię produktu";
translations[WAS_MEDICATION_ADDITIVE] = "Czy do produktu dodano lek, dodatek lub roztwór do rozpuszczania?";
translations[WHAT_MEDICATION_ADDITIVE] = "Jaki lek, dodatek lub roztwór do rozpuszczania został dodany?";
translations[WHAT_STATE_OF_PRODUCT] = "Jaki był stan produktu w przypadku zaobserwowania zmętnienia/osadu?";
translations[AFTER_UNITS_SAT] = "Czy po tym, jak jednostki osiadły i osiągnęły temperaturę pokojową, zmętnienie/osad ustąpiło?";
translations[DID_ATTEMPT_AGITATE] = "Czy została podjęta próba zmieszania/ wstrząsania jednostką?";
translations[DID_PRECIPITATE_DISSOLVE] = "Czy osad się rozpuścił?";
translations[WHAT_STORAGE_TEMPERATURE] = "Jaka była temperatura i warunki przechowywania produktu?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Podaj temperaturę, lokalizację, przechowywanie wewnątrz lub na zewnątrz pokrowca/kartonu, w kartonie VSC/Pośrednim, Pojedyńcze Jednostki";
translations[ARE_TEMPERATURE_LOGS] = "Czy są dostępne rejestry temperatury zamrazarki/ek, w których produkt jest przechowywany?";
translations[LOGS_CAN_BE_ATTACHED] = "Rejestry mogą być dołączane bezpośrednio do tego formularza, jeśli są dostępne w momencie składania skargi";
translations[IS_THE_STORAGE_UNIT] = "Czy urządzenie do przechowywania (zamrażarka lub lodówka) jest skalibrowane i kontrolowane temperatury?";
translations[HOW_PRODUCT_THAWED] = "W jaki sposób produkt został rozmrożony?";
translations[WHAT_STORAGE_CONDITIONS] = "Jakie były warunki przechowywania produktu? (temperatura, lokalizacja, przechowywana wewnątrz lub na zewnątrz torebki/kartonu)";
translations[WAS_ANY_DAMAGE] = "Czy zaobserwowano jakikolwiek problem lub uszkodzenie produktu?";
translations[MORE_SPECIFIC_INFORMATION] = "Proszę podać bardziej szczegółowe informacje:";
translations[WHAT_PURPOSE_INDICATION] = "Jaki był cel/wskazanie leczenia pacjenta?";
translations[WHAT_ROUTE_ADMINISTRATION] = "Jaka była droga podawania?";
translations[WHAT_DATE_ADMINISTRATION] = "Jaka była data podawania i czas trwania?";
translations[WHAT_DOSAGE_STRENGTH] = "Jaka była dawka/siła podawana pacjentowi?";
translations[WAS_RECENT_PRESCRIPTION] = "Czy nastąpiła ostatnio zmiana recepty?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "Jakie były dane przechowywania/temperatury produktu (lokalizacja przechowywania/chłodziarki/zamrażarki itp.)?";
translations[WERE_ANY_ADJUSTMENTS] = "Czy były jakieś zmiany w roztworze lub dodatkach przed podaniem?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Wybierz najbardziej odpowiedni opis problemu:";
translations[SELECT_LABELING_ISSUE] = "Wybierz najbardziej odpowiedni opis problemu z etykietowaniem:";
translations[WAS_CONNECTION_SECURE] = "Czy połączenie było bezpieczne i całkowicie zaciśnięte?";
translations[WAS_EXPIRED_PRODUCT] = "Czy produkt, który był przeterminowany, był podawany pacjentowi?";
translations[WAS_COMPONENT_DAMAGED] = "Czy jakikolwiek element był uszkodzony?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Czy zostały zauważone jakieś nieprawidłowości/uszkodzenia produktu?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "Jaki jest numer zamówienia zakupu?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "Jaka była data podania?";
translations[WHAT_WAS_EXPIRATION_DATE] = "Jaka była data waznosci produktu?";
translations[DESCRIBE_WAS_INCORRECT] = "Opisz, co było nieprawidłowe, niekompletne, brakujące, nieczytelne na etykiecie lub co było zbyt podobne (do innego produktu) na etykiecie:";
translations[WHAT_SCANNER_USED] = "Jakiego rodzaju skaner został użyty?";
translations[WAS_OVERPOUCH_POUCH] = "Czy produkt był nadal w torebce lub woreczku podczas skanowania?";
translations[WHAT_BACKGROUND_COLOR] = "Jaki był kolor tła podczas skanowania?";
translations[DO_ALL_OF_THE_LABELS] = "Czy wszystkie etykiety (produkt, pudełko/karton, wysyłka/dystrybucja) zawierają te same informacje o produkcie?";
translations[PRODUCT_INFORMATION] = "Informacje o produkcie";
translations[IS_A_BARCODE_SCANNER] = "Czy skaner kodów kreskowych jest używany w Twojej placówce?";
translations[HOW_ARE_THESE_PRODUCTS] = "W jaki sposób te produkty są przechowywane w placówce?";
translations[WHAT_INFORMATION_INCORRECTLY] = "Jakie informacje były niepoprawnie wyświetlane podczas skanowania?";
translations[WAS_THERE_LEAK] = "Czy zaobserwowano wyciek lub wilgoć?";
translations[WHERE_LEAK_OBSERVED] = "Gdzie zaobserwowano przeciek, jaki składnik przeciekał?";
translations[WAS_FRANGIBLE_OBSERVED] = "Czy łamliwa część miała złamanie?";
translations[IS_MOISTURE_CLEAR] = "Czy wilgoć jest czysta?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Kto jest Twoim Dystrybutorem?";
translations[WHAT_MANUFACTURER_MEDICATION] = "Jaki jest producent, nazwa leku i wielkość fiolki?";
translations[WHAT_GAUGE_NEEDLE] = "Jaki jest wskaźnik użytej igły, producent i ilosc miejsce kóre zostały przebite?";
translations[WHAT_ADMINISTRATION_SET] = "Jaki zestaw administracyjny został użyty?";
translations[WAS_DIFFICULTY_SPIKING] = "Czy były trudności z przebiciem kolcem?";
translations[WERE_FOLLOWING_SCENARIOS] = "Czy wystąpił któryś z poniższych scenariuszy z wyciekiem?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "Czy zaobserwowano uszkodzenia lub wady?";
translations[WHAT_AMOUNT_PRESSURE] = "Jaka ilość ciśnienia została zastosowana i na jaki czas?";
translations[WAS_BAG_COMPLETELY] = "Czy worek był całkowicie i prawidłowo włożony do mankietu dociskowego (czy jeden koniec był poza mankietem ciśnieniowym)?";
translations[WHAT_MANUFACTURER_MODEL] = "Jaki jest producent, model i rozmiar mankietu ciśnieniowego?";
translations[WHAT_PRESSURE_PRIOR] = "Jakie było ciśnienie przed wykryciem wycieku?";
translations[LIST_THE_VAPORIZER] = "Podaj producenta waporyzatora i nazwę/model";
translations[APPROXIMATELY_HOW_MUCH] = "W przybliżeniu ile płynu zostało rozlane?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "Czy trudno było włożyć butelkę do waporyzatora?";
translations[WERE_VISIBLE_DEFECTS] = "Czy były jakieś widoczne wady?";
translations[SELECT_THE_OPTION] = "Wybierz opcję, która najlepiej opisuje problem z połączeniem";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Podaj informacje o drugim produkcie, który brał udział w problemie z połączeniem";
translations[WHICH_PART_SEPARATED] = "Która część (-i) produktu zostały oddzielone?";
translations[WHAT_COMPONENT_DISCOLORED] = "Jaki komponent jest odbarwiony?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Wybierz opcję, która najlepiej opisuje przebarwienia:";
translations[WAS_THE_SET_DISCOLORED] = "Czy zestaw był odbarwiony, gdy został wyjęty z opakowania?";
translations[DID_SET_CHANGE_COLOR] = "Czy zestaw zmienił kolor po dodaniu leku?";
translations[WHAT_MEDICATION_ADDED] = "Jakie leki zostały dodane przed zmianą koloru?";
translations[WHERE_MATERIAL_LOCATED] = "Gdzie znajdowała się cząstka stała/materiał obcy?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Opisz cząstki stałe/materiał obcy (wygląd/kolor/rozmiar):";
translations[WAS_EMBEDDED_PLASTIC] = "Czy cząstki stałe/obce materiały były luźne lub osadzone w plastiku?";
translations[WAS_THERE_A_PRECIPITATE] = "Czy wystąpił osad lub zmiana koloru infuzji/roztworu, którego nie oczekiwano?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "Jakie lekarstwo/roztwór zostały podane przez zestaw?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Gdzie wystąpiło uszkodzenie lub jakie komponenty zostały naruszone (wybierz wszystkie, których to dotyczy)?";
translations[WHAT_DAMAGE_ISSUE] = "Jaki rodzaj uszkodzenia/problemu zaobserwowano (wybierz wszystkie, których to dotyczy)?";
translations[DID_ISSUE_RESULT] = "Czy ten problem spowodował wyciek?";
translations[WAS_PATIENT_CONNECTED] = "Czy pacjent był podłączony do produktu?";
translations[WAS_PRODUCT_REPLACED] = "Czy produkt został zastąpiony nowym produktem?";
translations[WHICH_SITUATION_BEST] = "Która sytuacja najlepiej opisuje problem separacji/połączenia";
translations[SELECT_MOST_LABELING_ISSUE] = "Wybierz najbardziej odpowiedni opis problemu z etykietowaniem:";
translations[WHAT_INFORMATION_DISPLAYED] = "Jakie informacje zostały wyświetlone?";
translations[WHAT_SCANNER_WAS_USED] = "Jakiego rodzaju skaner został użyty?";
translations[INCLUDE_THE_MODEL_NAME] = "Uwzględnij nazwę modelu";
translations[WAS_PRODUCT_ORDERED] = "Czy produkt został zamówiony bezpośrednio od firmy Baxter czy innego dystrybutora?";
translations[WHERE_LEAK_COMING] = "Skąd pochodzi przeciek (wybierz wszystkie, których to dotyczy)?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "Czy wystąpił któryś z poniższych scenariuszy z wyciekiem?";
translations[WAS_POWER_INJECTOR] = "Czy produkt był używany z wtryskiwaczem mocy?";
translations[WHAT_INJECTOR_USED] = "Jaki wtryskiwacz mocy został użyty?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Producent, nazwa produktu, kod produktu, partia produktu";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Opisz, co było nieprawidłowe, niekompletne, brakujące, nieczytelne lub zmienione na etykiecie:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Podaj informacje o drugim produkcie, który brał udział w rozłączeniu";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Które komponenty miały pęknięcie lub zniszczenia?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Opisz dokładną lokalizację na rurze, która miała rozcięcie, otwór lub przecięcie:";
translations[WAS_LEAK_ORIGINATING] = "Czy wyciek pochodzący z otwarcia miejsca wstrzyknięcia";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Podaj informacje drugiego produktu, który był związany z problemem rozłączenia/połączenia";
translations[WHICH_SPECIFIC_BONDED] = "Które konkretne elementy sklejane zostały oddzielone?";
translations[WERE_VISIBLE_IRREGULARITIES] = "Czy wystąpiły jakiekolwiek widoczne nieprawidłowości/uszkodzenia danego produktu/komponentów";
translations[WAS_SUCCESSFUL_CONNECTION] = "Czy pomyślne połączenie lub odłączenie zostało ostatecznie ustalone (bez konieczności wymiany produktu)?";
translations[WAS_TOOL_USED_ASSIST] = "Czy jakiekolwiek narzędzie zostało użyte do połączenia/odłączenia?";
translations[WERE_LUER_CONNECTIONS] = "Czy wszystkie połączenia Luer zostały sprawdzone, aby upewnić się, że były one zabezpieczone przed użyciem (według kopii etykiety)";
translations[WAS_PRODUCT_SECURELY] = "Czy produkt był bezpiecznie połączony z innym produktem przed odłączeniem?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Która sytuacja najlepiej opisuje problem przepływu?";
translations[WHAT_FLOWING_BACKWARDS] = "Co płynęło wstecz?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Opisz komponenty, z których rozpoczął się przepływ zwrotny do miejsca, w którym się zatrzymał:";
translations[DO_SITUATIONS_APPLY] = "Czy któraś z tych sytuacji dotyczy tego wydarzenia?";
translations[WHICH_SPECIFIC_AREA] = "Który konkretny obszar zestawu lub komponentu był związany z problemami przepływu?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "Czy przepływ był wcześniej widziany poprzez zestaw lub komponent?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "Czy zaobserwowano którykolwiek z następujących objawów:";
translations[WHERE_SIMULTANEOUS_FLOW] = "W którym miejscu był równoczesny przepływ?";
translations[WHAT_TYPE_HANGER] = "Jaki rodzaj wieszaka został użyty?";
translations[WHAT_WAS_HANGER_LENGTH] = "Jaka była długość wieszaka i/lub producent?";
translations[WHICH_BAG_LOWER] = "Która torba znajdowała się niżej?";
translations[WHAT_Y_SITE_WAS] = "Do jakiego łącznika typu Y był podłączony dodatkowy zestaw?";
translations[WHAT_COMPONENT_WITHIN] = "Z jakiego składnika w zestawie nie można usunąć z roztworu lub krwi?";
translations[WAS_COMPONENT_SET_REPLACED] = "Czy komponent/zestaw został wymieniony po tym, jak nie można go było wyczyścić?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "Jaka była objętość płynu podawana pacjentowi i przepisany okres czasu?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "Jaka była objętość płynu faktycznie podawana pacjentowi i w jakim okresie czasu?";
translations[WAS_USED_WITH_PUMP] = "Czy zestaw był używany z pompą?";
translations[DID_CLAMP_FAIL] = "Czy zacisk nie zatrzymał lub nie kontrolował przepływu?";
translations[WHAT_CLAMP_FAILED] = "Jaki zacisk zawiódł?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Czy zaobserwowano jakieś problemy z zaciskiem?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "Czy którykolwiek z innych sytuacji opisuje problem produktu (wybierz wszystkie, których to dotyczy)?";
translations[DESCRIBE_ALARM_OBSERVED] = "Opisz zaobserwowany alarm:";
translations[INCLUDE_ANY_MESSAGES] = "Uwzględnij wszystkie komunikaty i kody błędów związane z alarmem";
translations[WHICH_CLAMP_HAD_ISSUE] = "Z którym zaciskiem wystąpił problem?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Jaki problem wystąpił z zaciskiem (wybierz wszystkie, których to dotyczy)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Wybierz sytuację najlepiej opisującą problem:";
translations[PROVIDE_MORE_DETAILS] = "Podaj więcej szczegółów na temat tego, jak produkt był trudny w użyciu:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Podaj więcej szczegółów na temat instrukcji, które były trudne do naśladowania/zrozumienia:";
translations[DESCRIBE_THE_SMELL] = "Opisz zapach i skąd pochodzi:";
translations[WAS_ISSUES_WITH_SET] = "Czy zaobserwowano jakieś problemy z zestawem?";
translations[WHERE_LEAK_LOCATED] = "Gdzie na produkcie wystąpił przeciek?";
translations[DID_OCCUR_WITH_LEAK] = "Czy wystąpiło którekolwiek z poniższych problemów z wyciekiem?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Podaj informacje o drugim produkcie, który brał udział w rozłączeniu";
translations[DID_OCCURRED_WITH_THE_LEAK] = "Czy wystąpił któryś z poniższych scenariuszy z wyciekiem?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Gdzie produkt został uszkodzony?";
translations[SELECT_ALL_APPLY] = "Zaznacz wszystkie, które mają zastosowanie";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Opisz zaobserwowane uszkodzenia";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "Jaki składnik produktu został odbarwiony?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Opisz obserwowany kolor (odcień, barwę, itp.):";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "Wewnątrz lub na zewnątrz pokrowca, temperatura, ekspozycja na światło itp.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Opisz dokładną lokalizację, wielkość, kształt i kolor cząstek stałych/materiału obcego:";
translations[DOES_THE_PARTICULATE_MATTER] = "Czy cząstki stałe/obce materiały wydają się być częścią produktu?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "Czy osadziły się cząstki stałe/materiały obce?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "Czy cząstki stałe/obce materiały wydają się być kawałkami materiału produktu?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Gdzie na produkcie wystąpił problem?";
translations[LIST_COMPONENTS_IF] = "Wymien listę komponentów. Jeśli zaangażowany był drugi produkt, należy podać producenta, nazwę produktu, kod produktu, partię produktu";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Czy zaobserwowano jakieś widoczne nieprawidłowości/szkody?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Wybierz opcję, która najlepiej opisuje problem przepływu";
translations[DESCRIBE_IRREGULARITIES] = "Opisz nieprawidłowości/uszkodzenia oraz czy przed połączeniem/odłączeniem zaobserwowano uszkodzenie lub jeśli wystąpiło podczas połączenia/odłączenia";
translations[HOW_PRODUCT_SETUP] = "Jak była konfiguracja produktu?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Wybierz najbardziej odpowiedni opis problemu z etykietowaniem:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Opisz, co było nieprawidłowe, niekompletne, brakujące, nieczytelne na etykiecie lub co było zbyt podobne (do innego produktu) na etykiecie:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "Czy produkt znajdujący się w kartonie wysyłkowym został uszkodzony?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "Jaki produkt miał zostać odebrany?";
translations[IF_PRODUCT_CODE_NOT] = "Jeśli kod produktu nie jest dostępny, proszę podać opis produktu";
translations[WAS_THE_CASE_MISSING] = "Czy w opakowaniu brakowało suchego lodu lub chłodzonych opakowań żelowych?";
translations[WHAT_CARRIER_DELIVERED] = "Jaki przewoźnik dostarczył Twój produkt?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "Jaki jest numer zamówienia zakupu?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "Jaka była ilość brakujących jednostek?";
translations[WAS_EXPIRED_PRODUCT_USE] = "Czy przeterminwany produkt był użyty?";
translations[APPLY_TO_EACH_UNIT] = "Jeśli zdarzenie wystąpiło w więcej niż jednej jednostce, poniższe pytania dotyczą każdej z nich.";
translations[TERMS_CONDITIONS] = "Zasady i Warunki";
translations[PRIVACY_POLICY] = "Polityka prywatności";
translations[PRIVACY_NOTICE] = "Oświadczenie o ochronie prywatności ";
translations[COOKIE_POLICY] = "Polityka plikow Cookie ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Zapytano lecz odpowiedź nieznana";
translations[OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE] = "Pracownik firmy Baxter";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Opiekun pacjenta";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Dystrybutor";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Personel medyczny";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Pacjent";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Inny";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Po użyciu";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Przed użyciem";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "Podczas konfiguracji/przygotowania/mieszania";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "Podczas terapii";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Wiele etapów";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "Nie określono";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Członek rodziny";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Pielęgniarka";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Pielęgniarka stażystka";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Inny Opiekun medyczny";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Lekarz";
translations[OPTION_UNITOPTIONS_BOXES] = "Pudełka";
translations[OPTION_UNITOPTIONS_PALLETS] = "Palety";
translations[OPTION_UNITOPTIONS_UNITS] = "Jednostki";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Sytuacja alarmowa";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Uszkodzenie";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Trudne w użyciu";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Odbarwione";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Problemy z przepływem";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Problemy z etykietą";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Wyciek/ Nadmierna wilgotność";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Ciało obce ";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Reakcja pacjenta/Działanie niepożądane ";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Zapytanie o produkt";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Separacja/Problemy z połączeniem";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Problem z wysyłką / Przeterminowany produkt ";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Kobieta";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Niezróżnicowany";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Mezczyzna";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Odmówić odpowiedzi";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Administrator/Nadzorca ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Inżynier Biomedyczny ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Przedstawiciel firmy";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Dentysta";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Dystrybutor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Członek Rodziny";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Użytkownik";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Pielęgniarka";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Pielęgniarka stażystka";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Inny Opiekun medyczny";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Farmaceuta";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Technik Farmaceuta";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Lekarz";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Pacjent";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Menedżer ds. Ryzyka";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Inne";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Skontaktuj sie z  dodatkową osobą kontaktową";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Skontaktuj sie ze mną";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Inny kontakt ";
translations[OPTION_REPORTEDTOOPTIONS_BAXTER] = "Baxter";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "China FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Health Kanada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Japan)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Australia)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "Zwierzę mogło spowodować problem";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Ostry przedmiot lub narzędzie zostało użyte do otwarcia kartonu lub torebki ";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "Produkt był narażony na nadmierną siłę (tzn. uderzenie, przewrócenie itp.) ";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "Przed wystąpieniem problemu Produkt był narażony lub przechowywany w ciepłym/zimnym środowisku ";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Karton";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Minicap";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Pokrowiec ";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "Zestaw transferowy był zbyt ciasny";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "Zestaw transferowy był zbyt luźny";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "Zestaw transferowy nie był w stanie całkowicie się zamknąć";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "Zestaw transferowy nie był w stanie całkowicie się otworzyć";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "Zacisk typu Twist był tak ciasny, że zestaw transferowy nie był w stanie otworzyć się w ogóle";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "Zacisk  typu Twist był tak ciasny, że zestaw transferowy nie był w stanie zamknąć się w ogóle";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Tak - doszło do uszkodzenia/problem z zestawem transferowym, uniemożliwiacym jej prawidłowe zamknięcie";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Tak - Minicap został nadmiernie dokręcony do zestawu transferu ręcznie lub za pomocą narzędzia/urządzenia wspomagającego";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Całkowicie zatrzymane bez płynącego płynu";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Ograniczony lub Częściowo płynący (powolny przepływ)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Skrzepła krew";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Fibryna";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Zgięcie";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Cząstka";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Materiał produktu";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Nadmiar jodu (brązowy) zidentyfikowany po połączeniu lub w opakowaniu";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Nadmiar wilgoci (przezroczyste kropelki) zidentyfikowany w opakowaniu";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Foliowe opakowanie uszkodzone przed otwarciem";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Opakowanie/Pudełko otwarte lub uszkodzone przed użyciem";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Gąbka wysuszona i biała";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Gąbka wysuszona z brązowawym kolorem";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "W opakowaniu wtórnym/pokrowcu";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Wewnątrz produktu/ścieżki płynu";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Wewnątrz kartonu wysyłkowego";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Na zewnątrz produktu";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "Na zewnątrz opakowania wtórnego/pokrowca";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Na zewnętrznej stronie kartonu wysyłkowego";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Trudności związane z połączeniem produktu z innym produktem";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Trudności odłączanie produktu od innego produktu ";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Rozdzielenie komponentów w jednym produkcie";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Oddzielenie/odłączenie produktu od innego produktu";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "TAK - pozostałości po gwintach";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "TAK - widoczna szkoda";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Tak - Inne (dowolny tekst)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Łamliwy";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Otwór na wieszak";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Port Wtrysku/Napełniania ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Port membrany";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Pokrowiec/narzuta";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Łata";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Gumowy Korek";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Karton wywyłkowy";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Folia termokurczliwa";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Pojemnik z roztworem";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Ochraniacz Końcówki ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Plomba zabezpieczająca przed manipulacją (Folia termokurczliwa)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Zgięty";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Złamany";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Pęknięty";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Rozcięty";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Zdeformowany ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Łuszczenie";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Otwór";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "Skręcony";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Stopiony";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Separacja warstw łaty";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Rozbite (szkło)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Nacięty";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Rozdarty";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "Roztwór nie płynąłby w ogóle";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "Roztwór by płynął bardzo powoli";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "Roztwór nie płynąłby (lub płynął powoli) podczas rekonstytucji lub mieszania";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Butelka";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Kontener";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Otwór na wieszak";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Poszewka";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Pokrowiec/narzuta";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Wskaźnik tlenu";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Łata";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Porty";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Roztwór";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Ochraniacz końcówki";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Komora aminokwasowa";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Komora glukozowa";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Komora lipidowa ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Dolna komora";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Górna komora";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Pęknięta/rozerwana uszczelka";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Źle zmontowany produkt/część";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Brakujący komponent";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Rozdzielony/rozłączony sklejony komponent (-y)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "Produkt przepełniony";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Produkt niedopełniony";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Problem z rekonstytucją ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "W opakowaniu wtórnym/pokrowcu";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "Wewnątrz kartonu wysyłkowego";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "Na zewnętrznej stronie kartonu wysyłkowego";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Wewnątrz roztworu/ścieżki płynu";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "Wewnątrz pojemnika waporyzatora (wziernika)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "Na zewnętrznej powierzchni produktu";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "Na zewnątrz opakowania wtórnego/pokrowcu";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "Na absorberze tlenu";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "Na plastrze transdermalnym";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Łamliwy";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Cząstki szkła";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Port";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Gumowy korek";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Rurki";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "Po dodaniu innego leku lub po rekonstytucji (fiolki)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Przed przebiciem lub rekonstytucją";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "Zimna (rozmrożone, ale jeszcze nie temperatura pokojowa)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Zamrożone";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Częściowo rozmrożone (kryształy lodu w roztworze) ";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Temperatura pokojowa";
translations[OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING] = "Baxter Jednostka odmrażania (BTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "Pozostawiona na lodzie w temperaturze pokojowej";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Lodówka";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Tak - były dowody uszkodzenia podczas wysyłki";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Tak - zaobserwowano przeciek";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "Tak - był otwór lub niekompletne uszczelnienie w torebce";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "Tak - były trudności z przekłuciem lub rekonstytucją";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "Tak - były trudności z łamliwością";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "Tak - była krystalizacja lub osad";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "Tak - było mętne/osad w produkcie Frozen Galaxy";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "Produkt nie zapewniał zamierzonego efektu lub był nieskuteczny (brak działania)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Niezamierzone działanie/reakcja. Proszę podać: (dowolny tekst)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Uszkodzony karton wysyłkowy podczas dostawy";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Dostarczono przeterminowany produkt ";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "Znaleziono rzeterminowany produkt";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problem z kodem kreskowym — nieprawidłowe informacje wyświetlane podczas skanowania";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Trudności ze skanowaniem/ brak możliwości zeskanowania kodu kreskowego";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Dostarczono przeterminowany produkt ";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Przeterminowany produkt został znaleziony na magazynie";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Nieczytelna etykieta";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Niepoprawna etykieta";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Niekompletna etykieta";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "Etykieta zbyt podobna do innego produktu";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Etykiety (produkty, pudełka/kartony, listy wysyłkowe nie mają tej samej informacji o produkcie)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Brakujący kod kreskowy";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "Karton/pudełko zawiera niewłaściwy lub zmieszany produkt";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Uszkodzony karton wysyłkowy podczas dostawy";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "dodatkowe jednostki zostały dostarczone";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Przeterminowany Produkt dostarczony";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Przeterminowany Produkt Znaleziony";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Część kartonu została otwarta lub nie zaklejona";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Informacja o produkcie na kartonie i etykiecie dystrybucyjnej nie pasują do produktu znajdującego się w kartonie";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Brakujące jednostki produktu";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Brak etykiety";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Data ważności";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Numer Partii ";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "Numer NDC";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "Zaobserwowane Kropelki/wilgoć wewnątrz pokrowca bez wycieku ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Wyciek";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Wyciek zaobserwowany, gdy worek jest wyciskany";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Roztwór przepływający obok łamliwych części ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "Zaobserwowano roztwór wewnątrz pokrowca bez wycieku ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Pomiędzy pokrowcem a głownym kontenerem";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "Połączenie pomiędzy dwoma produktami ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Kontener  - port/rurka membranowa";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Kontener - port wstrzykiwania/napełniania";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Kontener - Otwór na wieszak";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Kontener";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Łamliwy";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Gumowy Korek";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Folia termokurczliwa";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Osłona końcówki";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Adapter fiolki";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Przylegający Port";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Uszkodzenie (otwory, rozdarcia) w opakowaniu wtórnym lub kartonie pośrednim";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Narażenie na ekstremalne gorąco/zimno";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Wyciek na interfejsie waporyzatora";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "Otwieranie kartonu wysyłkowego nożykiem/ostrym przedmiotem ";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Zwierzęta (podrapane/przeżute)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Worek z roztworem pod ciśnieniem z mankietem ciśnieniowym lub innym urządzeniem";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Przylegający port";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Uszkodzenie (otwory, rozdarcia) w opakowaniu wtórnym lub kartonie pośrednim";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Uszkodzony karton wysyłkowy podczas dostawy";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Narażenie na ekstremalne gorąco/zimno";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Wyciek na interfejsie waporyzatora";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Otwieranie kartonu wysyłkowego z nożykiem/ostrym przedmiotem ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Zwierzęta (podrapane/przeżute)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Worek z roztworem pod ciśnieniem z mankietem ciśnieniowym lub innym urządzeniem";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Żadne z powyższych";
translations[NO_DESCRIBE_THE_COLOR] = "Nie - opisz kolor (dowolny tekst)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10 ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "Więcej niż 10 ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Mniej niż 1 ml";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Butelka";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Nakładka";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "Zawór/szyjka";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "Brak";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Trudności związane z połączeniem produktu z innym produktem";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Trudności odłączanie produktu od innego produktu ";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Rozdzielenie komponentów w jednym produkcie";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Oddzielenie/odłączenie produktu od innego produktu";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Komora kroplowa";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Rurki";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Inne - proszę podać (dowolny tekst)";
translations[OTHER_PLEASE_SPECIFY] = "Inne - proszę podać (dowolny tekst)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Biały/mętny";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Żółty/brązowawy";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "Inne - Proszę określić (dowolny tekst)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "W opakowaniu podstawowym/woreczku blistra";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "Wewnątrz ścieżki płynu IV (w przewodach)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Wewnątrz kartonu wysyłkowego";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Na zewnętrznej stronie kartonu wysyłkowego";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "Poza ścieżką płynu IV (zewnętrzna część przewodu)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Wbudowany";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Luźny";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "Nie dotyczy";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "Opisz kolor (dowolny tekst)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Tak - Zmiana w  kolorze";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Tak - wytrącenie";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Miejsce dostępu";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "Burrettes";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Zacisk";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Komora kroplowa";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Rurki";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Nieznane";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Filtry";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Złącze typu Luer";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Kolec";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Przecięty/ pękniety lub zepsuty komponent (-y)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Nieprawidłowo złożony komponent  (określ, dowolny tekst)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Zgięty/ zapadnięty komponent (-y)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Poluzowany komponent w opakowaniu";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Zdeformowany/ zniekształcony komponent (-y)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Brakujący komponent";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "Trudność połączenia produktu z innym produktem";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "Trudność odłączania produktu od innego produktu";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "Luźne połączenie";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Rozdzielenie/odłączenie produktu od innego produktu";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Rozdzielenie między dwoma połączonymi komponentami w jednym produkcie";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "Nie można połączyć dwóch produktów ze sobą";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "Nie można odłączyć produkt z innego produktu";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problem z kodem kreskowym — nieprawidłowe informacje wyświetlane podczas skanowania";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Zmiany w etykietowaniu ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Trudności ze skanowaniem, brak możliwości skanowania kodu kreskowego";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Produkt przeterminowany";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Nieprawidłowe informacje na etykiecie";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Brak kodów/ UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Brakujące informacje na etykiecie";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Produkt bez daty ważności";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Rozmazane/ nieczytelne etykiety ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "Karton/pudełko zawiera niewłaściwy lub zmieszany produkt ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Uszkodzony karton wysyłkowy podczas dostawy";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Przeterminowany Produkt dostarczony";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Przeterminowany Produkt Znaleziony";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER] = "Baxter";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR] = "Dystrybutor";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Dodatkowe jednostki zostały dostarczone";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Część kartonu została otwarta lub nie zapieczętowana";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Informacja o produkcie na kartonie i etykieta dystrybucyjna nie pasują do produktu znajdującego się wewnątrz";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "Brakujące jednostki produktu";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Dostęp do witryny";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Odpowietrznik";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Burettes";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Nakładka";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Clearlink miejsca wstrzyknięcia";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Zacisk";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Komora kroplowa";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filtry";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Interlink Miejsca wstrzyknięcia";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Złącze typu Luer";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Kolec";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Rurki";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Wyciek między miejscem wstrzyknięcia i rurką";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Igłowe miejsce wstrzyknięcia";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "One-Link miejsca wstrzyknięcia";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Inne miejsca wstrzyknięcia (dowolny tekst)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "Pęknięcie/przerwanie w sztywnych elementach zestawu";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "Rozciecie/przecięcie w miękkiej rurce";
translations[DISCONNECTION_OF_CONNECTABLE] = "Odłączenie łącznych komponentów/produktów połączonych";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Odłączenie łącznych komponentów/produktów połączonych";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Rozdzielenie elementów sklejonych";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Tak - Opisz nieprawidłowości/uszkodzenia (tekst dowolny)";
translations[YES_SPECIFY_THE_TOOL] = "Tak - Określ używane narzędzie (tekst dowolny)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Przepływ wsteczny/ zwrotny";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Awaria zacisku - Trudności z zacisnnięciem (ale w stanie ostatecznie zamknąć) ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Awaria zacisku - Nie można zamknąć całkowicie ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Awaria zacisku - trudność/niezdolność do otwarcia";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Brak przepływu";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Nadmierna dawka";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Ograniczony/powolny przepływ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Jednoczesny przepływ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Nie można usunąć komponentu";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Brak mozliwosc wyplukania/ zalania ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Niewystarczająca dawka";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Krew pacjenta (nie podawana w infuzji produktów z krwi)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Roztwory/Produkty krwiopochodne ";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Wyciek/dziura";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Odłączenie";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Wyciek";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "Lek podawano za pomocą strzykawki pod ciśnieniem lub pompy IV ";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "Worek wtórny znajdował sie niżej niż worek głowny.";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "Worek wtórny znajdował sie na tej samej wysokośći co worek główny";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Krzepnięcie krwi";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "Cewnik nie był w stanie być przepłukany przed przymocowaniem do zestawu";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Zgięta rurka";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Zablokowanie rurek/miejsca wstrzyknięcia";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Pierwotny i wtórny pojemnik (dodatkowy)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Dwa lub więcej przewodów płynących w zestawie wielowodowym";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "Dwa zestawy podawania każdy z własną pompą infuzyjną";
translations[OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER] = "Wieszak Baxter";
translations[OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER] = "Wieszak Non-Baxter ";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "Torby były na tej samej wysokości";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Podstawowe";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Wtórne";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Środkowy";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "Dolny";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Górny";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Tak - Podaj nazwę i kod produktu pompy (tekst dowolny)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Ciemnoniebieski zacisk typu Slide";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Jasnoniebieski zacisk  typu Slide";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Zacisk nacinający";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Zacisk rolkowy";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "Biały zacisk typu Slide";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Tak - zacisk został złamany lub pęknięty";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "Powietrze w linii";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Problem z zaciskiem";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "Zapach";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Zacisk nacinający/ zaciskowy";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Zacisk Rolkowy";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Zacisk typu Slide";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Inny (dowolny Tekst)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "Pęknięty/Przerwany";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "Trudne do otwarcia";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "Trudne do zamknięcia";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "Brakujący";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Nie można otworzyć";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "Nie można zamknąć";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "Nie można kontrolować przepływu";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "Trudno wycisnąć komorę kroplową";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Instrukcje były trudne do naśladowania/zrozumienia";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "Produkt był trudny w użyciu";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Pęknięcia/przerwanie";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Cięcie/rozcięcie/przecięcie";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Odłączenie łącznych komponentów/produktów połączonych";
translations[DISCONNECTION_OF_CONNECTABLE] = "Odłączenie łącznych komponentów/produktów połączonych";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "Dziura/ rozdarcie";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Rozdzielenie elementów sklejonych";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Przylegający port";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Uszkodzenie (otwory, rozdarcia) w opakowaniu wtórnym lub kartonie pośrednim";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Uszkodzony karton wysyłkowy podczas dostawy";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Narażenie na ekstremalne gorąco/zimno";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Otwieranie kartonu wysyłkowego z nożykiem/ostrym przedmiotem ";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "Żadne z powyższych";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Ciśnieniowy  rękaw lub wtryskiwacz ciśnienia użyty";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Przylegający Port";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Port przegryziony przez zwierzęta (podrapany/przeżuty)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Produkt";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "Karton/pudełko do wysyłki";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "Wewnątrz produktu";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Wewnątrz kartonu wysyłkowego";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Na zewnątrz produktu";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Trudności związane z połączeniem produktu z innym produktem";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Trudności odłączania produktu od innego produktu ";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Luźne połączenie";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Rozdzielenie komponentów w pojedyńczym produkcie";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Oddzielenie/odłączenie produktu od innego produktu";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Na zewnątrz kartonu wysyłkowego";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "Wewnątrz opakowania wtórnego/pokrowca";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "Na zewnątrz opakowania wtórnego/pokrowca";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Niepłynące";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "Ograniczone lub Częściowo płynące";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problem z kodem kreskowym — nieprawidłowe informacje wyświetlane podczas skanowania";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Trudności ze skanowaniem/ brak możliwości zeskanowania kodu kreskowego";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Nieczytelna etykieta";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Nieprawidłowa etykieta";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Niekompletna etykieta";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Etykiety (produkty, pudełka/kartony, listy wysyłkowe nie mają tej samej informacji o produkcie)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Etykieta zbyt podobna do innego produktu";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Brak etykiety";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Brakujący kod kreskowy";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "Zamrożony produkt został dostarczony";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "Rozmrożony produkt został dostarczony";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Tak, Alarm nie znany";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Tak, Określ";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Tak - zestaw transferowy nie mógł być całkowicie otwarty";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Tak - zestaw transferowy nie mógł być całkowicie zamknięty";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "Tak - Zacisk typu Twist był tak ciasny, że zestaw transferowy nie był w stanie otworzyć się w ogóle";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "Tak - Zacisk  typu Twist był tak ciasny, że zestaw transferowy nie był w stanie zamknąć się w ogóle";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Pudełko lub pokrowiec";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Niebieski zacisk na końcowej linii napełniania";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Kaseta";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Złącze przewodu odpływowego i Nakładka z pierścieniem ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Miejsce pobierania próbek linii ścieków";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Linie ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Luer/ złacze kolca";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Organizator";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Nakładka z pierścieniem/ ochraniacz końcówki na linii pacjenta";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Nakładka z pierścieniem/ochraniacz końcówki ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Czerwony zacisk na lini grzewczej";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Punkt zgrzewania/klejenia";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "Biały zacisk na linii ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Beżowe złącze/adapter cewnika";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Chip Insert";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Ciemnoniebieskie Złącze";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Jasnoniebieski korpus główny";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Jasnoniebieska nakładka z pierścieniem";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Jasnoniebieski nózki  okkludera";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Silikonowe Rurki";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Tytanowy kolec";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "Kolec UV Flash ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "Biały zacisk typu Twist/Rękaw";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Tak: Opisz zniszczenie (dowolny tekst)";
translations[OPTION_MONTHOPTIONS_JAN] = "Styczeń";
translations[OPTION_MONTHOPTIONS_FEB] = "Luty";
translations[OPTION_MONTHOPTIONS_MAR] = "Marzec";
translations[OPTION_MONTHOPTIONS_APR] = "Kwiecień";
translations[OPTION_MONTHOPTIONS_MAY] = "Maj";
translations[OPTION_MONTHOPTIONS_JUN] = "Czerwiec";
translations[OPTION_MONTHOPTIONS_JUL] = "Lipec";
translations[OPTION_MONTHOPTIONS_AUG] = "Sierpień";
translations[OPTION_MONTHOPTIONS_SEP] = "Wrzesień";
translations[OPTION_MONTHOPTIONS_OCT] = "Październik";
translations[OPTION_MONTHOPTIONS_NOV] = "Listopad";
translations[OPTION_MONTHOPTIONS_DEC] = "Grudzień";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Inne";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Inne";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Inny (dowolny tekst)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "Żadne z powyższych";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "Nie";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Tak";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "Nie";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Tak";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "Nie";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Tak";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "Nie";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Tak";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Zapytano lecz odpowiedź nieznana";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "Nie";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Nieznane";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Tak";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "Nie";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Tak";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "Nie";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Tak";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "Nie";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Tak";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "Nie";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Tak";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "Nie";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Tak";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "Nie";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Tak";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "Nie";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Tak";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "Nie";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Tak";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "Nie";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Tak";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "Nie";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Tak";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "Nie";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Tak";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "Nie";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Tak";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "Nie";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Tak";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "Nie";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "Nie";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Tak";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "Nie";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Tak";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "Nie";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Tak";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "Nie";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Tak";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "Nie";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Tak";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "Nie";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Tak";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "Nie";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Tak";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "Nie";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Tak";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "Nie";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Tak";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "Nie";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Tak";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "Nie";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "Nie";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Tak";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "Nie";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Tak";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "Nie";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Tak";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "Nie";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Nieznane";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Tak";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "Nie";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Tak";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "Nie";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Tak";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "Nie";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Tak";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "Nie";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Tak";
translations[OPTION_vaporizerSightGlassOptions_NO] = "Nie";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Nieznane";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Tak";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "Nie";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Tak";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "Nie";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Tak";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "Nie";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Tak";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "Nie";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Tak";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "Nie";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Tak";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "Nie";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Tak";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "Nie";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Tak";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "Nie";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Tak";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "Nie";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Tak";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "Nie";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Nieznane";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Tak";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "Nie";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Tak";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "Nie";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Tak";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "Nie";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Tak";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "Nie";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Tak";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "Nie";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Tak";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "Nie";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Tak";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "Nie";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Tak";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "Nie";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Tak";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "Nie";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Tak";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Tak";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "Nie";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Tak";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "Nie";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Tak";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "Nie";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Tak";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Nieznana";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "Nie";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Tak";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "Nie";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Tak";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "Nie";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Tak";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "Nie";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Tak";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "Nie";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Tak";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "Nie";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Tak";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "Nie";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Tak";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "Nie";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "Nie";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Tak";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "Nie";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "Nie";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Tak";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "Nie";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Tak";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "Nie";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Tak";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "Nie";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Tak";
translations[OPTION_WITHPUMPOPTIONS_NO] = "Nie";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "Nie";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Tak";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "Nie";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "Nie";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Tak";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "Nie";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Tak";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "Nie";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Tak";
translations[OPTION_GELPACKSOPTIONS_NO] = "Nie";
translations[OPTION_GELPACKSOPTIONS_YES] = "Tak";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "Nie";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Tak";
translations[OPTION_ALARMOPTIONS_NO] = "Nie";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "Nie";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Tak";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "Nie";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "Nie";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Tak";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "Nie";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Tak";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "Nie";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Nieznane";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "Nie";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Tak";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Inne (dowolny tekst)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "Nie";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Tak";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "Nie";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Tak";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "Nie";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Tak";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Zapytano lecz odpowiedź nieznana";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Zapytano lecz odpowiedź nieznana";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Nieznana";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "Nie";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Żadne z powyższych";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "Nie - opisz kolor (dowolny tekst)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Tak - Określ używane narzędzie (tekst dowolny)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Oddzielenie";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "Brak";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Tak - Inne (dowolny tekst)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Nieznany";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "Brak";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Kilogram (-y) ";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "funt (-y)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "Nie";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Nieznany";
translations[PLEASE_ENTER_THE_VALUE] = "Wprowadź wartość";
translations[PLEASE_SELECT_THE_VALUE] = "Proszę wybrać wartość";
translations[PLEASE_SELECT_THE_DATE] = "Wybierz datę";
translations[PLEASE_CHOOSE_THE_VALUE] = "Proszę wybrać wartość";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Nieznane";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "WIELKA BRYTANIA";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOWO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "IRLANDIA PÓŁNOCNA";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "WYSPY ALANDZKIE";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBANIA";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ALGIERIA";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "SAMOA AMERYKAŃSKIE";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILLA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTARKTYDA";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA I BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTYNA";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIA";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRALIA";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "AUSTRIA";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBEJDŻAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMY";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHRAJN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESZ";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BIAŁORUŚ";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BELGIA";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDY";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIWIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOŚNIA I HERCEGOWINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "WYSPA BOUVETA";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRAZYLIA";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "BRYTYJSKIE TERYTORIUM OCEANU INDYJSKIEGO";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BUŁGARIA";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "KAMBODŻA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "KAMERUN";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "KANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "WYSPY ZIELONEGO PRZYLĄDKA";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "KAJMANY";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "REPUBLIKA ŚRODKOWOAFRYKAŃSKA";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "CZAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CHINY";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "WYSPA BOŻEGO NARODZENIA";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "WYSPY KOKOSOWE (KEELINGA)";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "KOLUMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "KOMORY";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "KONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "DEMOKRATYCZNA REPUBLIKA KONGA";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "WYSPY COOKA";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "KOSTARYKA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "WYBRZEŻE KOŚCI SŁONIOWEJ";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "CHORWACJA";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "KUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CYPR";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "CZECHY";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DANIA";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DŻIBUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINIKA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "DOMINIKANA";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "EKWADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGIPT";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "SALWADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "GWINEA RÓWNIKOWA";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERYTREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTONIA";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETIOPIA";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "FALKLANDY (MALWINY)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "WYSPY OWCZE";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIDŻI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINLANDIA";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANCJA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "GUJANA FRANCUSKA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "POLINEZJA FRANCUSKA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "FRANCUSKIE TERYTORIA POŁUDNIOWE";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABON";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GRUZJA";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "NIEMCY";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GRECJA";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GRENLANDIA";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRENADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADELUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GWATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GWINEA";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEA BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUJANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "WYSPA HEARD I WYSPY MCDONALD";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "WATYKAN";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONG KONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "WĘGRY";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ISLANDIA";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "INDIE";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONEZJA";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAK";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRLANDIA";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "WYSPA MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "IZRAEL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "WŁOCHY";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAJKA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "JAPONIA";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDANIA";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KAZACHSTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENIA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "KOREA, DEMOKRATYCZNA REPUBLIKA LUDOWA";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "REPUBLIKA KOREI";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWEJT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KIRGISTAN";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "LAOTAŃSKA REPUBLIKA LUDOWO-DEMOKRATYCZNA";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "ŁOTWA";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LIBAN";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTHO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBIA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LICHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITWA";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUKSEMBURG";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MAKAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDONIA";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASKAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALEZJA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALEDIWY";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "WYSPY MASHALLA";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTYNIKA";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURETANIA";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURITIUS";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAJOTTA";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MEKSYK";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "MIKRONEZJA";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOŁDAWIA";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONAKO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLIA";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MAROKO";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOZAMBIK";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "HOLANDIA";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NOWA KALEDONIA";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NOWA ZELANDIA";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NIKARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "WYSPA NORFOLK";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "MARIANY PÓŁNOCNE";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NORWEGIA";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "TERYTORIUM PALESTYŃSKIE";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA NOWA GWINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGWAJ";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "FILIPINY";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLSKA";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTUGALIA";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "KATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "RUMUNIA";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "FEDERACJA ROSYJSKA";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RWANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SAINT BARTHÉLEMY";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "WYSPA ŚWIĘTEJ HELENY";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SAINT KITTS I NEVIS";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SAINT LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SAINT-MARTIN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAINT-PIERRE I MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAINT VINCENT I GRENADYNY";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "WYSPY ŚWIĘTEGO TOMASZA I KSIĄŻĘCA";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "ARABIA SAUDYJSKA";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERBIA";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SESZELE";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPUR";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "SŁOWACJA";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "SŁOWENIA";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "WYSPY SALOMONA";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "REPUBLIK POŁUDNIOWEJ AFRYKI";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "GEORGIA POŁUDNIOWA I SANDWICH POŁUDNIOWY";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "HISZPANIA";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAM";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD I JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SZWAJLANDIA";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "SZWECJA";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "SZWAJCARIA";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SYRIA";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAJWAN";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TADŻYKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZANIA";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "TAJLANDIA";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR WSCHODNI";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRYNIDAD I TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNEZJA";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "TURCJA";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "WYSPY TURKS I CAICOS";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UKRAINA";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "ZJEDNOCZONE EMIRATY ARABSKIE";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "ZJEDNOCZONE KRÓLESTWO";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "STANY ZJEDNOCZONE AMERYKI PÓŁNOCNEJ";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "DALEKIE WYSPY MNIEJSZE STANÓW ZJEDNOCZONYCH";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGWAJ";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "UZBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "WENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "WIETNAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "BRYTYJSKIE WYSPY DZIEWICZE";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "AMERYKAŃSKIE WYSPY DZIEWICZE";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS AND FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "ZACHODNIA SAHARA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "JEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBABWE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "Nie";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Nieznane";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Tak";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Przeczytałem i rozumiem powiązaną Informację o ochronie prywatności dla Portalu opinii o produktach firmy Baxter. ";
translations[PRODUCT_LOT] = "Partia/e  produktu";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Etykieta wysyłkowa/dystrybucyjna";
translations[CARTON_LABEL] = "Etykieta kart";
translations[INTERNAL_PRODUCT_LABEL] = "Wewnętrzna etykieta produktu";
translations[TITLE_PD_RENAL] = "PD nerek";
translations[TITLE_SOLUTIONS] = "Rozwiązania";
translations[TITLE_ACCESS] = "Dostęp";
translations[TITLE_ALL_OTHER_PRODUCT] = "Wszystkie inne produkty";
translations[REPORTED_PROBLEM] = "Zgłoszony problem";
translations[LOGIN] = "Zaloguj sie";
translations[SYSTEM_MENU] = "Menu systemowe";
translations[INITIATE_PRODUCT_FEEDBACK] = "Rozpocznij opinię o produkcie";
translations[FEEDBACK_STATUS] = "Stan opinii";
translations[OKTACALLBACK] = "OktaOddzwonienie";
translations[VALID_EMAIL] = "Podaj prawidłowy adres e-mail";
translations[VALID_NUMERIC] = "Wprowadź numer";
translations[PLEASE_UPLOAD_IMAGE] = "Proszę przesłać zdjęcie/cia";
translations[VALID_DATE] = "Proszę wybrać prawidłową datę";
translations[QUANTITY] = "Ilość";
translations[EDIT] = "Edytować";
translations[DELETE] = "Usuwać";
translations[LOT_SERIAL_NO] = "Numer partii/seryjny";
translations[LOT_NUMBER_NOT_FOUND] = "Nie znaleziono numeru partii";
translations[SEARCHING_LOT_NUMBER] = "Wyszukiwanie numeru partii";
translations[PRODUCT_CODE_NOT_FOUND] = "Nie znaleziono kodu produktu";
translations[SEARCHING_PRODUCT_CODE] = "Wyszukiwanie kodu produktu";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Typy plików (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) są niedozwolone";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "Plik, który próbujesz dołączyć, przekracza limit miejsca. Skompresuj go lub załącz inny plik.";
translations[IMAGE_ICON] = "Kliknij ikonę obrazu, aby wybrać opcję";
translations[LOGIN_TO_ACCOUNT] = "Zaloguj się do konta";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Zaloguj się";
translations[BAXTER_EMAIL_ADDRESS] = "Adres e-mail firmy Baxter";
translations[PASSWORD] = "Hasło";
translations[SIGN_IN] = "Zaloguj się";
translations[UNKNOWN] = "Nieznane";
translations[ASKED_UNKNOWN] = "Zapytano lecz odpowiedź nieznana";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Wybierz kraj";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Chiński (chiński uproszczony)";
translations[DUTCH] = "Holenderski";
translations[ENGLISH] = "Angielski";
translations[FRENCH] = "Francuski";
translations[GERMAN] = "Niemiecki";
translations[ITALIAN] = "Włoski";
translations[JAPANESE] = "Japoński";
translations[KOREAN] = "Koreański";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandaryński (tradycyjny chiński) ";
translations[POLISH] = "Polski";
translations[PORTUGUESE] = "Portugalski";
translations[SPANISH] = "Hiszpański";
translations[THAI] = "Tajski";
translations[TURKISH] = "Turecki";
translations[VIETNAMESE] = "Wietnamski";
translations[BROWSE] = "Przeglądaj";
translations[FEEDBACK_SUBMITTED] = "Przesłano opinię";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "Twoja opina o produkcie zostala pomyslnie przesłana. Dziękuję za raport. Otrzymasz wiadomość e-mail z numerem referencyjnym. Jako dostawca produktów medycznych, zadowolenie klientów i opinie o naszym produkcie są niezbędne do osiągnięcia naszego celu, jakim jest dostarczanie produktów najwyższej jakości. Proszę o kontakt";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "jeśli masz pytania lub dodatkowe informacje.";
translations[CLOSE] = "zamknąć";
translations[PATIENT_AGE] = "Wiek pacjenta";
translations[ENTER_AGE] = "Wpisz wiek";
translations[PATIENT_DOB] = "Data urodzenia Pacjenta";
translations[RELEVANT_ATTACHMENTS] = "Proszę dodać odpowiednie załączniki";
translations[BAXTER_ACCOUNT_CREDENTIALS] = "Wprowadź dane uwierzytelniające swojego konta Baxter";
translations[GET_PRODUCT_DETAILS] = "Uzyskaj szczegółowe informacje o produkcie";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Skorzystaj z powyższego diagramu (rysunek 2), aby określić lokalizację zgłaszanego problemu";
translations[FACILITY_ADDRESS] = "Adres placówki";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Inny adres placówki";
translations[CHOOSE_PRODUCT_CODE] = "Wybierz kod produktu dla wprowadzonego numeru partii/serii";
translations[DECLINE] = "Odmawiam";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT EUSTATIUS I SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURAÇAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "POŁUDNIOWY SUDAN";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "oznacza, że ​​dla tego pola dostępny jest tekst pomocy";
translations[YOUR_FIRST_NAME] = "Twoje imię";
translations[YOUR_LAST_NAME] = "Twoje nazwisko";
translations[MY_FIRST_NAME] = "Moje imię";
translations[MY_LAST_NAME] = "Moje nazwisko";
translations[PATIENT_FIRST_NAME] = "Imię pacjenta";
translations[PATIENT_LAST_NAME] = "Nazwisko pacjenta";
translations[REPORTER_FIRST_NAME] = "Imię osoby zgłaszającej";
translations[REPORTER_LAST_NAME] = "Nazwisko osoby zgłaszającej";
translations[EMPLOYEE_FIRST_NAME] = "Imię pracownika";
translations[EMPLOYEE_LAST_NAME] = "Nazwisko pracownika";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Imię użytkownika końcowego/klienta";
translations[END_USER_CUSTOMER_LAST_NAME] = "Nazwisko użytkownika końcowego/klienta";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Imię dodatkowej osoby do kontaktu";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Nazwisko dodatkowej osoby do kontaktu";
translations[COPYRIGHT] = "Prawa autorskie ©";
translations[COPYRIGHT_BAXTER] = "Baxter";
translations[COPYRIGHT_VERSION] = "Wszelkie prawa zastrzeżone | Wersja";
translations[ADD_ADDITIONAL_CONTACT] = "Dodaj dodatkową osobę do kontaktu";
translations[CONTACT_ME] = "Klient nie życzy sobie kontaktu. Skontaktuj się ze mną w razie dodatkowych pytań.";
translations[DO_NOT_CONTACT] = "Nie kontaktuj się";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Nazwa placówki użytkownika końcowego/klienta";
translations[END_USER_CUSTOMER_PHONE] = "Numer telefonu placówki użytkownika końcowego/ klienta";
translations[END_USER_CUSTOMER_EMAIL] = "Adres e-mail użytkownika końcowego/klienta";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Adres placówki użytkownika końcowego/klienta";
translations[SAME_AS_PATIENT_ADDRESS] = "Taki sam jak adres pacjenta";
translations[SAME_AS_REPORTER_ADDRESS] = "Taki sam jak adres osoby raportującej";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Taki sam jak adres placówki użytkownika końcowego/klienta";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Użyj powyższego diagramu (rysunek 3), aby określić lokalizację zgłoszonego problemu";
translations[CONTACT_US] = "Skontaktuj się z nami";
translations[LANDING_BRIEF_FOR_DEVICE] = "W sprawie naprawy urządzenia, części, serwisu lub pomocy technicznej, skontaktuj się z lokalnym zespołem pomocy technicznej.";
translations[PATIENT_SEX] = "Seks pacjenta";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Cispłciowy mężczyzna/chłopiec";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Kobieta/dziewczyna cispłciowa";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Transpłciowy mężczyzna/transpłciowy mężczyzna/kobieta na mężczyznę (FTM)";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Kobieta transpłciowa/kobieta transpłciowa/z mężczyzny na kobietę";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Inna kategoria płci; proszę sprecyzuj";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Odmówić odpowiedzi";
translations[ATTENTION_NEEDED] = "!!! PILNA UWAGA POTRZEBNA: Przesłanie portalu opinii o produktach nie powiodło się!";
translations[SUBMIT_ERR_MSG] = "Aby ponownie przesłać, kliknij przycisk OK, a następnie Prześlij lub, wyślij skargę e-mailem na adres (@@@).";
translations[SUBMIT_RETRY_MSG] = "Jeśli przesłałeś ponownie, upewnij się, że otrzymałeś wiadomość e-mail z potwierdzeniem w swojej skrzynce e-mail z portalu opinii o produktach. Jeśli nie otrzymałeś wiadomości e-mail z potwierdzeniem, przesłanie nie zakończyło się sukcesem i MUSISZ wysłać skargę e-mailem na adres (@@@).";
translations[OK] = "OK";

export default lang;